import FJTextToImageDataConfig from '../config/dataConfig/FJTextToImageDataConfig';
import FJConfig from '../config/FJConfig';
import FJS3Config from '../config/FJS3Config';
import FJAppConstant from '../constants/FJAppConstant';
import FJConstant from '../constants/FJConstant';
import FJImageStore from '../store/FJImageStore';
import FJNetworkStore from '../store/FJNetworkStore';
import Download from '../lib/download';
import FJUtil from './FJUtil';
import FJS3NetworkManager from '../store/FJS3NetworkManager';
import FJMessageStore from '../store/FJMessageStore';
import FJLocalStore from '../store/FJLocalStore';
import FJFaceSwapConfig from '../config/appConfig/FJFaceSwapConfig';
import FJAIVideoGeneratorConfig from '../config/appConfig/FJAIVideoGeneratorConfig.js';
import FJClothesChangerConfig from '../config/appConfig/FJClothesChangerConfig.js';
import { MAX_POLLING_ERROR_TIME, TASK_POLLING_INTERVAL } from '../config/dataConfig/FJGenerateData.js';
import FJHeaderConfig from '../config/FJHeaderConfig.js';
import FJTextToSpeechUtil from './FJTextToSpeechUtil.js';
import FJVideoUtil from './FJVideoUtil.js';
import {
    AI_GENERATOR_VIDEO_TAB_TYPE,
    AI_VIDEO_GENERATION_MODEL_LIST,
    MODEL_VALUE_MAP,
    IMAGE_UPLOAD_MODES,
} from '../config/dataConfig/FJAIVideoGeneratorData.js';
import { STYLE_LIST } from '../config/dataConfig/FJImageToImageData.js';
import {
    getHairstyleAndColorInfo,
    HAIR_STYLE_NO_CHANGE_KEY,
    HAIR_COLOR_NO_CHANGE_KEY,
} from '../config/dataConfig/FJHairstyleChangerDataConfig.js';
import FJHeadshotUtil from './FJHeadshotUtil.js';
import { AI_PHOTO_EDITOR_MODELS } from '../config/dataConfig/FJAIPhotoEditorData.js';
import FJImageToImageConfig from '../config/appConfig/FJImageToImageConfig.js';
import FJTextToImageConfig from '../config/appConfig/FJTextToImageConfig.js';
import FJAIPhotoEditorConfig from '../config/appConfig/FJAIPhotoEditorConfig.js';
import FJVideoRemoveBgConfig from '../config/appConfig/FJVideoRemoveBgConfig.js';
import FJAiVideoDubConfig from '../config/appConfig/FJAiVideoDubConfig.js';
import { LOCAL_STRING_LIST } from '../config/dataConfig/FJCommonDataConfig.js';
let _abTestId = Math.ceil(Math.random() * 10);
const FJRequirementsUtil = {
    isLocalhost: function () {
        return Boolean(
            window.location.hostname === 'localhost' ||
            // [::1] is the IPv6 localhost address.
            window.location.hostname === '[::1]' ||
            // 127.0.0.1/8 is considered localhost for IPv4.
            window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/) ||
            window.location.hostname.match(/^192.168(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){2}$/),
        );
    },
    getUserId() {
        let uid;
        if (window?.fjuser?.info?.id) {
            uid = window.fjuser.info.id;
        } else {
            uid = '';
        }
        return uid;
    },
    getCurrentSpaceId: function () {
        return window.fjuser.info.current_space_id;
    },
    getCurrentSpaceType: function () {
        return window.fjuser?.info?.space_type || 'personal';
    },
    isTeamSpace: function () {
        return FJUtil.getCurrentSpaceType() === 'team';
    },
    // 是否是团队管理员
    isTeamOwner: function () {
        return this.isTeamSpace() && window.fjuser?.info?.space_permission === 'owner';
    },
    anonymousSignUp: function () {
        return new Promise((resolve, reject) => {
            try {
                window.PanelFunc.showSignUpPane();
                window.loginToCreateProjectCallback = () => {
                    resolve();
                };
            } catch (e) {
                reject(e);
            }
        });
    },
    getLanguage: function (tag, callback) {
        fetch(FJConfig.languagePath + tag + '.json?v=' + FJConfig.version)
            .then(res => res.json())
            .then(json => {
                callback(json);
            })
            .catch(err => {
                console.log(err);
            });
    },
    /**
     * @desc 添加统计
     * @param {string} eventType - 类型
     * @param {{}} eventData - 数据
     */
    eaLog(eventType, eventData = {}) {
        const data = {
            ...eventData,
            'app mode': 'ai tools',
            'app version': FJConfig.version,
            page: window.isEditPage ? 'editor' : 'tools page',
        };

        if (window.ealog && window.ealog.addEvent) {
            window.ealog.addEvent(eventType, data);
        } else {
            console.log(eventType, data);
        }
    },
    /**
     * @desc 获取积分
     * @param {*} appType （不传就从FJConfig.appType获取）
     */
    getCredits: function (appType) {
        const position = FJUtil.getToolName() + ' window';
        const aiToolName = FJUtil.getToolName(appType);
        this.eaLog('get credits click', { position, 'ai tool name': aiToolName });
        const isFreePayment = FJUtil.isFreePayment();
        // TODO 如果是编辑页内嵌版本，则使用编辑页的升级流程
        if (window.isEditPage && window.EDIT_PAGE_API && window.EDIT_PAGE_API.showUpgrade) {
            window.EDIT_PAGE_API.showUpgrade();
        } else if (window.openSubscription) {
            window.openSubscription({
                panelName: 'Credits',
                entry: aiToolName,
                showCreditRuleTable: false,
                showQuestionnaire: false,
                useNewCreditModal: true,
                useNewCreditModalABtest: isFreePayment,
            });
        }
    },
    isLogin: function () {
        return FJRequirementsUtil.isLocalhost() || (window.uid && window.uid !== -1);
    },
    login: function (loginCallback) {
        FJUtil.anonymousSignUp()
            .then(() => {
                if (loginCallback) {
                    loginCallback();
                } else {
                    FJUtil.updateAllCreditInfo();
                }
            })
            .catch(e => console.log(e));
    },
    checkIsLogin: async function (loginCallback, errorCallback) {
        const __login = () => {
            FJUtil.anonymousSignUp()
                .then(() => {
                    if (loginCallback) {
                        loginCallback();
                    } else {
                        FJUtil.updateAllCreditInfo();
                    }
                })
                .catch(e => console.log(e));
        };
        try {
            if (FJUtil.isLocalhost()) {
                return true;
            }
            if (!FJUtil.isLogin()) {
                __login();
                return false;
            } else {
                const isLogin = await FJNetworkStore.checkIsLogin();
                if (!isLogin) {
                    __login();
                    return false;
                }
            }
            return true;
        } catch (error) {
            if (errorCallback) {
                errorCallback();
            } else {
                FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
            }
            return false;
        }
    },

    /**
     * 检查用户状态
     * @returns 0: 正常 1: 网络错误 2: 未登录 3: 切换用户 4: 个人切换团队  5:切换团队
     */
    checkUserSpace: async function (options = {}) {
        const { loginCallback, errorCallback, beforeLoginCallback, callback } = options;
        const __login = () => {
            beforeLoginCallback && beforeLoginCallback();
            FJUtil.anonymousSignUp()
                .then(() => {
                    loginCallback && loginCallback();
                    FJUtil.updateAllCreditInfo();
                })
                .catch(e => console.log(e));
        };
        let spaceType = 1;
        try {
            if (FJUtil.isLocalhost()) {
                spaceType = 0;
            } else if (!FJUtil.isLogin()) {
                __login();
                spaceType = 2;
            } else {
                if (window.isEditPage) {
                    spaceType = 0;
                } else {
                    const spaceData = await FJNetworkStore.getSpaceData();
                    const isMobile = FJUtil.isMobile();
                    if (spaceData.uid == 0) {
                        //未登录
                        __login();
                        spaceType = 2;
                    } else if (spaceData.uid != FJUtil.getUserId()) {
                        //切换用户
                        spaceType = 3;
                    } else if (spaceData.space_type != FJUtil.getCurrentSpaceType()) {
                        //个人团队切换
                        // TODO：团队 移动端暂时不区分团队
                        spaceType = isMobile ? 0 : 4;
                    } else if (spaceData.current_space_id != FJUtil.getCurrentSpaceId()) {
                        //切换团队
                        spaceType = isMobile ? 0 : 5;
                    } else {
                        //正常
                        spaceType = 0;
                    }
                }
            }
        } catch (error) {
            if (errorCallback) {
                errorCallback();
            } else {
                FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
            }
            spaceType = 1;
        }
        callback && callback(spaceType);
        return spaceType;
    },
    getTimeDiff: function (startTime, endTime) {
        if ((!startTime && startTime !== 0) || (!endTime && endTime !== 0) || startTime > endTime) {
            return;
        }
        const DIFF = 5;
        // 计算时间差（单位：毫秒）
        let timeDiff = endTime - startTime;
        // 转换为秒
        let seconds = Math.floor(timeDiff / 1000);
        // 输出或显示记时时间
        let min = Math.floor(seconds / DIFF) * DIFF;
        let max = Math.ceil(seconds / DIFF) * DIFF;
        if (min === max) {
            min -= DIFF;
        }
        return min + '-' + max;
    },
    /**
     * @desc: 更新所有位置用户积分界面
     * @param {boolean} updateFreeLimit - 是否更新免费额度(使用了免费次数需要更新)
     */
    updateAllCreditInfo: function (updateFreeLimit) {
        if (window.fj && window.fj.event && window.fj.event.dispatch) {
            window.fj.event.dispatch('UPDATE_USER_CREDITS', updateFreeLimit);
        }
    },
    parseList: async function (list, options = {}) {
        if (!list) return [];
        const {
            type,
            isUploadWaterMark = false,
            resultImageKey = FJConfig.resultImageKey,
            originalImageKey = FJConfig.originalImageKey,
            appType = FJConfig.appType,
        } = options;
        let uploadWaterMarkList = [];
        let arr = [];

        const __getResultImageKey = job_type => {
            if (job_type === 3) {
                return FJImageToImageConfig.resultImageKey;
            } else if (job_type === 6) {
                return FJTextToImageConfig.resultImageKey;
            } else if (job_type === 36) {
                return FJAIPhotoEditorConfig.resultImageKey;
            } else {
                return resultImageKey;
            }
        };

        const __getOriginalImageKey = job_type => {
            if (job_type === 3) {
                return FJImageToImageConfig.originalImageKey;
            } else if (job_type === 6) {
                return FJTextToImageConfig.originalImageKey;
            } else if (job_type === 36) {
                return FJAIPhotoEditorConfig.originalImageKey;
            } else {
                return originalImageKey;
            }
        };

        const __getResultUrl = (imageName, options = {}) => {
            if (imageName && appType === FJAppConstant.FACE_SWAP && imageName.includes('target')) {
                return FJFaceSwapConfig.thoseTargetImagesPath + imageName;
            } else if (appType === FJAppConstant.AI_VIDEO_GENERATOR) {
                const { job_type } = options;
                // 判断是视频特效
                if (job_type === FJAIVideoGeneratorConfig.videoEffectJobType) {
                    return FJS3Config.S3_SERVER_HOST + FJAIVideoGeneratorConfig.resultVideoEffectKey + imageName;
                }

                return FJS3Config.S3_SERVER_HOST + FJAIVideoGeneratorConfig.resultVideoKey + imageName;
            }

            const { job_type } = options;
            const useResultImageKey = __getResultImageKey(job_type);
            return FJS3Config.S3_SERVER_HOST + useResultImageKey + imageName;
        };
        const __getOriginalUrl = (imageName, options = {}) => {
            if (!imageName) return '';

            if (imageName && appType === FJAppConstant.FACE_SWAP && imageName.includes('origin')) {
                return FJFaceSwapConfig.thoseOriginImagesPath + imageName;
            }

            const { job_type } = options;
            const useOriginalImageKey = __getOriginalImageKey(job_type);
            return FJS3Config.S3_SERVER_HOST + useOriginalImageKey + imageName;
        };

        const __getCoverUrl = (imageName, isCustomRemoveBg = true, options = {}) => {
            if (appType === FJAppConstant.VIDEO_REMOVE_BG) {
                if (isCustomRemoveBg) {
                    return FJS3Config.S3_SERVER_HOST + FJVideoRemoveBgConfig.resultCoverKey + imageName + '.png';
                } else {
                    return (
                        FJS3Config.S3_SERVER_HOST +
                        FJVideoRemoveBgConfig.resultCoverKey +
                        imageName.replace('.webm', '.png')
                    );
                }
            } else if (appType === FJAppConstant.AI_VIDEO_DUB) {
                return FJS3Config.S3_SERVER_HOST + FJAiVideoDubConfig.resultCoverKey + imageName + '.png';
            }

            const { job_type } = options;
            // 判断是视频特效
            if (job_type === FJAIVideoGeneratorConfig.videoEffectJobType) {
                return (
                    FJS3Config.S3_SERVER_HOST +
                    FJAIVideoGeneratorConfig.resultVideoEffectCoverKey +
                    imageName.replace('.mp4', '.png')
                );
            }

            return (
                FJS3Config.S3_SERVER_HOST + FJAIVideoGeneratorConfig.resultCoverKey + imageName.replace('.mp4', '.png')
            );
        };

        const __getOriginImagePathInVideo = (imageName, source) => {
            switch (source) {
                case 1:
                    return FJS3Config.S3_SERVER_HOST + FJAIVideoGeneratorConfig.originImagePath[0] + imageName;
                case 2:
                    return FJS3Config.S3_SERVER_HOST + FJAIVideoGeneratorConfig.originImagePath[1] + imageName;
                case 3:
                    return FJS3Config.S3_SERVER_HOST + FJAIVideoGeneratorConfig.originImagePath[2] + imageName;
                case 4:
                    return window.location.origin + FJAIVideoGeneratorConfig.originImagePath[3] + imageName;
                case 5: {
                    return 'https://resource.flexclip.com/pages/ai-banners/ai-image-to-video/' + imageName;
                }
            }
        };

        const __getOriginImagePathInEffectVideo = info => {
            if (info) {
                try {
                    const tempInfo = JSON.parse(info);
                    if (typeof tempInfo.input === 'string') {
                        return [__getOriginImagePathInVideo(tempInfo.input, 1)];
                    } else {
                        return tempInfo.input.map(item => __getOriginImagePathInVideo(item, 1));
                    }
                } catch (error) {
                    return [];
                }
            }
        };
        // 整理原始图片列表
        const _getOriginalImages = obj => {
            const { singleImage, startImage, endImage, multiImage, inputImages, referenceImages, originalUrl, effectInfo } =
                obj;
            try {
                if (singleImage) {
                    return [singleImage];
                } else if (startImage || endImage) {
                    return [startImage, endImage].filter(Boolean);
                } else if (multiImage) {
                    return multiImage.filter(Boolean);
                } else if (inputImages) {
                    return inputImages.filter(Boolean);
                } else if (referenceImages) {
                    return referenceImages.filter(Boolean);
                } else if (originalUrl) {
                    return [originalUrl];
                } else if (effectInfo?.effectOriginalUrlList?.length > 0) {
                    return effectInfo.effectOriginalUrlList.filter(Boolean);
                }
            } catch (error) {
                console.error(error);
                return [];
            }
            return [];
        };
        for (let i = 0; i < list.length; i++) {
            const item = list[i];
            let imgUrl = __getResultUrl(item.result, { job_type: item.job_type });
            const { width, height, depth_map_info, isCustomRemoveBg, garment, clothes_model_type } = JSON.parse(
                item.info || '{}',
            );
            if (item.has_watermark && isUploadWaterMark) {
                const resultUrl = FJS3Config.S3_NOT_CATCH_HOST + resultImageKey + item.result;
                const watermarkImgBlob = await FJImageStore.drawWatermarkOnPicture(resultUrl);
                const key = resultImageKey + item.result;
                uploadWaterMarkList.push({ file: watermarkImgBlob, key });
            }

            let model = item?.request_params?.model || item?.request_params?.model_type;

            let obj = {
                id: item.id,
                imgUrl,
                type,
                width,
                height,
                originalUrl: __getOriginalUrl(item.original, { job_type: item.job_type }),
                createTime: item.created_at,
                hasWaterMark: item.has_watermark,
                shareKey: item.share_key,
                style: item?.style || item?.request_params?.style,
                model: model,
                ratio: item?.request_params?.ratio,
                upscaleSize: item?.request_params?.super_resolution_factor,
                textToImagePrompt: item?.request_params?.input_prompt,
                jobType: item?.job_type,
                depthMapInfo: depth_map_info,
                eventId: item.event_id,
                isCustomRemoveBg: isCustomRemoveBg,
                appType,
                privacyStatus: item?.privacy_status,
                likeNum: item?.like_num,
                isLike: item?.is_like,
                uid: item?.user_id,
                communityId: item?.community_id,
                modelType: item?.request_params?.model_type,
            };
            if (appType === FJAppConstant.FAKE_3D) {
                obj.imgUrl = __getOriginalUrl(item.original);
                obj.depthMapUrl = __getResultUrl(item.result);
                depth_map_info?.originWidth && (obj.width = depth_map_info.originWidth);
                depth_map_info?.originHeight && (obj.height = depth_map_info.originHeight);
            } else if (appType === FJAppConstant.AI_VIDEO_GENERATOR) {
                if (item.job_type === FJAIVideoGeneratorConfig.videoEffectJobType) {
                    const generationType = 'ev';
                    const status = item?.request_params?.state;
                    obj.imgUrl =
                        status === 'completed' ? __getCoverUrl(item.result, true, { job_type: item.job_type }) : null;
                    obj.videoUrl =
                        status === 'completed' ? __getResultUrl(item.result, { job_type: item.job_type }) : null;
                    obj.status = item?.request_params?.state;
                    obj.aspectRatio = item?.request_params?.aspect_ratio;
                    obj.generationType = generationType;
                    obj.modelType = item?.request_params?.model_type;
                    obj.prompt = item?.request_params?.prompt;
                    obj.duration = item?.request_params?.duration;
                    obj.originalUrl = __getOriginImagePathInVideo(item.original, item?.request_params?.source);

                    obj.effectInfo = {
                        effect_scene: item?.request_params?.effect_style,
                        effectOriginalUrlList: __getOriginImagePathInEffectVideo(item.info),
                        effect_input_video_url: item?.request_params?.input_video_urls,
                    };
                    const STANDARD_RATIOS = {
                        '16:9': 16 / 9, // 1.778
                        '9:16': 9 / 16, // 0.5625
                        '1:1': 1,
                    };
                    // 优先从图片宽高计算比例
                    if (width && height) {
                        obj.ratio = width / height;
                    } else if (item?.request_params?.waterfall_ratio) {
                        // 从瀑布流比例计算比例
                        obj.ratio = item?.request_params?.waterfall_ratio;
                    } else {
                        // 从标准比例计算比例
                        obj.ratio = STANDARD_RATIOS[item?.request_params?.aspect_ratio] || 16 / 9;
                    }
                } else {
                    const generationType = item?.request_params?.generation_type;
                    const status = item?.request_params?.state;
                    let currentModelConfig = AI_VIDEO_GENERATION_MODEL_LIST.find(
                        _item => _item.value === item?.request_params?.model_type,
                    );
                    // 兼容旧模型
                    if (item?.request_params?.model_type === 'v1.5') {
                        currentModelConfig = AI_VIDEO_GENERATION_MODEL_LIST.find(
                            _item =>
                                _item.value ===
                                (generationType === 'iv' ? MODEL_VALUE_MAP.PRO_I2V : MODEL_VALUE_MAP.PRO_T2V),
                        );
                    } else if (item?.request_params?.model_type === 'standard') {
                        currentModelConfig = AI_VIDEO_GENERATION_MODEL_LIST.find(
                            _item => _item.value === MODEL_VALUE_MAP.STANDARD,
                        );
                    }
                    obj.imgUrl =
                        status === 'completed' ? __getCoverUrl(item.result, true, { job_type: item.job_type }) : null;
                    obj.videoUrl =
                        status === 'completed' ? __getResultUrl(item.result, { job_type: item.job_type }) : null;
                    obj.status = item?.request_params?.state;

                    const isHideAspectRatio = !currentModelConfig?.supportImageSelectRatio && generationType === 'iv';
                    obj.aspectRatio = isHideAspectRatio ? null : item?.request_params?.ratio;
                    obj.ratio = width && height ? width / height : item?.request_params?.waterfall_ratio;
                    obj.generationType = generationType;
                    obj.modelType = currentModelConfig?.value;
                    obj.model = currentModelConfig?.name;
                    obj.prompt = item?.request_params?.prompt;
                    obj.duration = item?.request_params?.duration;
                    obj.orientation = item?.request_params?.orientation;
                    obj.videos = item?.request_params?.videos;
                    // 文生视频没有原始图片显示
                    obj.originalUrl =
                        generationType === 'tv'
                            ? null
                            : __getOriginImagePathInVideo(item.original.split(',')[0], item?.request_params?.source);
                    obj.sfxSupported = currentModelConfig?.sfxSupported;
                    obj.currentImageMode = item?.request_params?.current_image_mode || currentModelConfig?.mode;

                    obj.errorCode = item?.error_code;
                    const { request_params = {} } = item;
                    const { image, images = [], start_image, end_image, multi_image } = request_params;
                    switch (currentModelConfig?.mode) {
                        case IMAGE_UPLOAD_MODES.SINGLE:
                            obj.singleImage = image || images?.[0] || obj.originalUrl;
                            break;
                        case IMAGE_UPLOAD_MODES.START_END:
                            obj.startImage = start_image || images?.[0] || obj.originalUrl;
                            obj.endImage = end_image || images?.[1];
                            break;
                        case IMAGE_UPLOAD_MODES.MULTI:
                            obj.multiImage = multi_image ||
                                (images && Object.values(images).filter(Boolean)) || [obj.originalUrl];
                            break;
                    }
                }
            } else if (appType === FJAppConstant.VIDEO_REMOVE_BG) {
                obj.isCustomRemoveBg = !item?.request_params?.is_auto_remove;
                obj.videoUrl = __getResultUrl(item.result);
                obj.imgUrl = obj.isCustomRemoveBg ? __getCoverUrl(obj.eventId) : __getCoverUrl(item.result, false);
            } else if (appType === FJAppConstant.TEXT_TO_SPEECH) {
                const { name, avatar, select_lang, text } = JSON.parse(item.info);
                obj.audioUrl = FJS3Config.S3_SERVER_HOST + FJConfig.resultAudioKey + item.result;
                obj.name = name;
                obj.avatar = avatar;
                obj.lang = select_lang;
                obj.readText = text;
            } else if (appType === FJAppConstant.CLOTHES_CHANGER) {
                obj.clothesModelType = clothes_model_type;
                if (garment)
                    obj.garment = `${FJS3Config.S3_NOT_CATCH_HOST}${FJClothesChangerConfig.originalImageKey}${garment}`;
            } else if (appType === FJAppConstant.AI_VIDEO_DUB) {
                obj.videoUrl = __getResultUrl(item.result);
                obj.imgUrl = __getCoverUrl(obj.eventId);
                obj.prompt = item?.request_params?.input_prompt || item?.request_params?.prompt;
            } else if (appType === FJAppConstant.AI_HAIRSTYLE_CHANGER) {
                const { gender, hair_color, haircut } = item.request_params;
                const { hairstyle: hairstyleInfo, hairColor: hairColorInfo } = getHairstyleAndColorInfo(
                    gender,
                    haircut,
                    hair_color,
                );
                obj.hairstyleInfo = hairstyleInfo;
                obj.hairColorInfo = hairColorInfo;
            } else if (appType === FJAppConstant.PHOTO_RESTORATION || appType === FJAppConstant.PHOTO_COLORIZE) {
                const color = item?.request_params?.colorize;
                obj.color = color;
            } else if (appType === FJAppConstant.OBJECT_ERASER) {
                obj.prompt = item.request_params?.original_prompt;
            } else if (item.job_type === 36) {
                obj.prompt = item.request_params?.original_prompt;
                obj.model = AI_PHOTO_EDITOR_MODELS.find(item => item.value === model)?.name || model;
                obj.quality = item.request_params?.quality;
                if (item.request_params?.input_images && item.request_params?.input_images.length > 1) {
                    obj.inputImages = item.request_params?.input_images?.map(item => item);
                } else {
                    obj.inputImage = item.request_params?.input_image || item.request_params?.input_images?.[0] || null;
                }
            } else if (item.job_type === 6) {
                obj.model = FJTextToImageDataConfig.MODELS.find(item => item.value === model)?.name || model;
                obj.quality = item.request_params?.quality;
                // 参考图
                if (item.request_params?.input_images && item.request_params?.input_images.length) {
                    obj.referenceImages = item.request_params?.input_images?.map(item => item);
                } else {
                    obj.referenceImages = item.request_params?.input_image ? [item.request_params?.input_image] : null;
                }

                // obj.referenceImages = item.request_params?.input_image ? [item.request_params?.input_image] : null;
            } else if (appType === FJAppConstant.HEADSHOT_GENERATOR) {
                obj.eventId = item.event_id;
                obj.status = item.status;
                obj.name = item.name;
                obj.category = item.category;
                obj.id = item.event_id;
                // 处理头像生成数据
                const [headshotList, info] = FJHeadshotUtil.getHeadshotListAndInfo(
                    item.headshot_list,
                    __getResultUrl,
                    __getOriginalUrl,
                );
                obj.headshotList = headshotList;
                obj.jobType = info.job_type;
                obj.createdAt = info.created_at;
                obj.jobState = info.job_state;
            }
            obj.originalImages = _getOriginalImages(obj);
            arr.push(obj);
        }
        if (uploadWaterMarkList.length) {
            await FJS3NetworkManager.batchUploadToS3(uploadWaterMarkList);
        }

        return arr;
    },
    createPlaceHolderList: function (options) {
        const {
            count,
            uploadImageInfo,
            selectedStyle,
            prompt,
            isUploadS3,
            uploadS3Url,
            type = FJConstant.CREATIONS,
            generateInfo,
        } = options;
        const list = [];
        for (let i = 0; i < count; i++) {
            const item = {
                id: new Date().getTime() + i,
                imgUrl: '',
                createTime: '',
                hasWaterMark: false,
                originalUrl: uploadS3Url || uploadImageInfo.src,
                width: uploadImageInfo.width,
                height: uploadImageInfo.height,
                isLoading: true,
                type,
                isReload: false,
                isUploadS3,
            };
            selectedStyle && (item.style = selectedStyle);
            generateInfo && (item.generateInfo = generateInfo);
            prompt && (item.style = prompt);
            list.push(item);
        }
        return list;
    },
    createPlaceHolderListNew: function (options) {
        const { count, width, height, type = FJConstant.CREATIONS, generateInfo } = options;
        const list = [];
        for (let i = 0; i < count; i++) {
            const item = {
                id: new Date().getTime() + i,
                imgUrl: '',
                hasWaterMark: false,
                width,
                height,
                isLoading: true,
                type,
                isReload: false,
            };
            generateInfo && (item.generateInfo = generateInfo);
            list.push(item);
        }
        return list;
    },
    getPreviewSize: function (viewSize) {
        const { width, height } = viewSize;
        const ratio = width / height;
        let w = 458;
        let h = 256;
        if (ratio > 21 / 9) {
            w = 458;
            h = 256;
        } else if (ratio >= 16 / 9) {
            w = 458;
            h = w / ratio;
        } else if (ratio >= (1 + 16 / 9) / 2) {
            h = 256;
            w = h * ratio;
        } else if (ratio >= 1) {
            w = 380;
            h = w / ratio;
        } else if (ratio > (1 + 9 / 16) / 2) {
            h = 380;
            w = h * ratio;
        } else if (ratio >= 9 / 16) {
            w = 280;
            h = w / ratio;
        } else if (ratio >= 9 / 21) {
            h = 445;
            w = h * ratio;
        } else {
            h = 445;
            w = 280;
        }
        return { width: w, height: h };
    },
    isGeneratingStatus: function (status) {
        return [FJConstant.START, FJConstant.WAITING, FJConstant.GENERATING].includes(status);
    },
    multiDownloadByUrls: async (urls, callback, options = {}) => {
        if (!urls.length) {
            callback && callback(false);
            return;
        }
        const {
            isVideo = false,
            errorMessage,
            isAudioGenerator = false,
            isWebm = false,
            downloadHistoryList = [],
            isZipDownload = false,
        } = options;

        const _getFileName = () => {
            const now = new Date();
            // 获取年、月、日、时、分、秒
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1并补零
            const day = String(now.getDate()).padStart(2, '0'); // 补零
            const hours = String(now.getHours()).padStart(2, '0'); // 补零
            const minutes = String(now.getMinutes()).padStart(2, '0'); // 补零
            const seconds = String(now.getSeconds()).padStart(2, '0'); // 补零

            // 格式化日期和时间为 2024-07-17T111525
            return `Made with FlexClip AI-${year}-${month}-${day}T${hours}${minutes}${seconds}`;
        };
        try {
            if (urls.length === 1 && !isZipDownload) {
                if (isVideo) {
                    const blob = await FJUtil.downloadVideoCacheAvoidance(urls[0]);
                    if (!blob) throw new Error();
                    const name = _getFileName() + (isWebm ? '.webm' : '.mp4');
                    Download(blob, name, 'video/mp4');
                } else if (isAudioGenerator) {
                    const blob = await FJUtil.downloadVideoCacheAvoidance(urls[0]);
                    if (!blob) throw new Error();
                    const audioName = downloadHistoryList[0].audioName;
                    const isMp3 = audioName.endsWith('.mp3');
                    const name = audioName + '-' + _getFileName() + (isMp3 ? '.mp3' : '.wav');
                    Download(blob, name, isMp3 ? 'audio/mpeg' : 'audio/wav');
                } else {
                    const blob = await FJUtil.downloadImageCacheAvoidance(urls[0]);
                    if (!blob) throw new Error();
                    const name = _getFileName() + '.png';
                    Download(blob, name, 'image/png');
                }

                FJMessageStore.addMessage(FJLocalStore._('download-successfully'));
                callback && callback(true);
            } else {
                let Blobs = [];
                const folderName = _getFileName();
                for (let i = 0; i < urls.length; i++) {
                    const url = urls[i];
                    let blob;
                    if (isVideo) {
                        blob = await FJUtil.downloadVideoCacheAvoidance(url);
                        if (!blob) throw new Error();
                        blob.name = _getFileName() + i + '.mp4';
                        Blobs.push(blob);
                    } else if (isAudioGenerator) {
                        const blob = await FJUtil.downloadVideoCacheAvoidance(url);
                        if (!blob) throw new Error();
                        const isMp3 = url.endsWith('.mp3');
                        blob.name = _getFileName() + i + (isMp3 ? '.mp3' : '.wav');
                        Blobs.push(blob);
                    } else {
                        blob = await FJUtil.downloadImageCacheAvoidance(url);
                        if (!blob) throw new Error();
                        blob.name = _getFileName() + i + '.png';
                        Blobs.push(blob);
                    }
                }
                FJUtil.saveBlobsInZip(Blobs, folderName);
                FJMessageStore.addMessage(FJLocalStore._('download-successfully'));
                callback && callback(true);
            }
        } catch (e) {
            FJMessageStore.addMessage(
                errorMessage ? errorMessage : FJLocalStore._('failed-to-download-please-try-again'),
                'error',
            );
            callback && callback(false);
        }
    },
    multiDownloadByBlobs: async (blobs, callback) => {
        if (!blobs.length) {
            callback && callback(false);
            return;
        }
        const _getFileName = () => {
            const now = new Date();
            // 获取年、月、日、时、分、秒
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1并补零
            const day = String(now.getDate()).padStart(2, '0'); // 补零
            const hours = String(now.getHours()).padStart(2, '0'); // 补零
            const minutes = String(now.getMinutes()).padStart(2, '0'); // 补零
            const seconds = String(now.getSeconds()).padStart(2, '0'); // 补零

            // 格式化日期和时间为 2024-07-17T111525
            return `Made with FlexClip AI-${year}-${month}-${day}T${hours}${minutes}${seconds}`;
        };
        try {
            if (blobs.length === 1) {
                const blob = blobs[0];
                if (!blob) throw new Error();
                const name = _getFileName() + '.png';
                Download(blob, name, 'image/png');
                callback && callback(true);
                FJMessageStore.addMessage(FJLocalStore._('download-successfully'));
            } else {
                let Blobs = [];
                const folderName = _getFileName();
                for (let i = 0; i < blobs.length; i++) {
                    const blob = blobs[i];
                    if (!blob) throw new Error();
                    blob.name = _getFileName() + i + '.png';
                    Blobs.push(blob);
                }
                FJUtil.saveBlobsInZip(Blobs, folderName);
                FJMessageStore.addMessage(FJLocalStore._('download-successfully'));
                callback && callback(true);
            }
        } catch (e) {
            FJMessageStore.addMessage(FJLocalStore._('failed-to-download-please-try-again'), 'error');
            callback && callback(false);
        }
    },

    /**
     * @desc 更新页面标题
     * @param {string} appType
     */
    updateDocumentTitle: function (appType) {
        try {
            let title = '';
            switch (appType) {
                case FJAppConstant.CLOTHES_CHANGER:
                    title = 'ai-clothes-changer';
                    break;
                case FJAppConstant.IMAGE_TO_IMAGE:
                    title = 'ai-image-to-image';
                    break;
                case FJAppConstant.IMAGE_ENHANCER:
                    title = 'ai-image-upscaler';
                    break;
                case FJAppConstant.TEXT_TO_IMAGE:
                    title = 'ai-text-to-image';
                    break;
                case FJAppConstant.PHOTO_RESTORATION:
                    title = 'ai-old-photo-restoration';
                    break;
                case FJAppConstant.PHOTO_COLORIZE:
                    title = 'ai-photo-colorizer';
                    break;
                case FJAppConstant.FACE_SWAP:
                    title = 'ai-face-swap';
                    break;
                case FJAppConstant.IMAGE_EXTENDER:
                    title = 'ai-image-extender';
                    break;
                case FJAppConstant.FAKE_3D:
                    title = '3d-photo-animation';
                    break;
                case FJAppConstant.OBJECT_ERASER:
                    title = 'ai-object-eraser';
                    break;
                case FJAppConstant.AI_VIDEO_GENERATOR:
                    title = FJVideoUtil.getAiGeneratorVideoTab();
                    break;
                case FJAppConstant.PHOTO_REMOVE_BG:
                    title = 'ai-image-bg-remover';
                    break;
                case FJAppConstant.AI_AUDIO_GENERATOR:
                    title = 'ai-music-generator';
                    break;
                case FJAppConstant.VIDEO_REMOVE_BG:
                    title = 'ai-video-bg-remover';
                    break;
                case FJAppConstant.AI_VIDEO_DUB:
                    title = 'ai-video-dub';
                    break;
                case FJAppConstant.AI_TEXT_BASED_EDITING:
                    title = 'ai-text-based-editing';
                    break;
                case FJAppConstant.TEXT_TO_FULL_VIDEO:
                    title = 'ai-text-to-full-video';
                    break;
                case FJAppConstant.BLOG_URL_TO_VIDEO:
                    title = 'ai-blog-url-to-video';
                    break;
                case FJAppConstant.PRODUCT_URL_TO_VIDEO:
                    title = 'ai-product-url-to-video';
                    break;
                case FJAppConstant.PPT_TO_VIDEO:
                    title = 'ai-ppt-to-video';
                    break;
                case FJAppConstant.TEXT_TO_SPEECH: {
                    const localPath = window.location.pathname;
                    const keys = localPath.split('/');
                    const info = {
                        'text-to-speech': 'ai-text-to-speech',
                        'voice-cloning': 'ai-voice-cloning',
                    };
                    for (const key in info) {
                        const result = keys.find(value => value && value === key);
                        if (result) {
                            title = info[key];
                            break;
                        }
                    }
                    break;
                }
                case FJAppConstant.AI_HAIRSTYLE_CHANGER:
                    title = 'ai-hairstyle-changer';
                    break;
                case FJAppConstant.WATERMARK_REMOVER:
                    title = 'ai-watermark-remover';
                    break;
                case FJAppConstant.AI_PHOTO_EDITOR:
                    title = 'ai-photo-editor';
                    break;
                case FJAppConstant.HEADSHOT_GENERATOR:
                    title = 'ai-headshot-generator';
                    break;
                case FJAppConstant.AI_COMMUNITY:
                    title = 'ai-community';
                    break;
                default:
                    break;
            }
            title = FJLocalStore._(title) + ' | FlexClip';
            document.title = title;
        } catch (e) {
            console.log(e);
        }
    },
    getImgToImgDataStyleItem: function (value) {
        for (const category of STYLE_LIST) {
            const item = category.list.find(item => item.value === value);
            if (item) {
                return {
                    ...item,
                    categoryName: category.categoryName,
                };
            }
        }
        return null;
    },

    parseModalInfoList: function (data, appType, options = {}) {
        const {
            createTime,
            style,
            width,
            height,
            model,
            ratio,
            aspectRatio,
            upscaleSize,
            isVideoGeneration,
            modelType,
            isCustomRemoveBg,
            generationType,
            hairstyleInfo,
            hairColorInfo,
            color,
            clothesModelType, // 换装模型类型
            quality, // 图片质量
        } = data;

        const { videoEffectStyleItem = {} } = options;
        let list = [];

        if (generationType === 'ev' && appType === FJAppConstant.AI_VIDEO_GENERATOR) {
            list.push({
                title: 'effect',
                content: FJLocalStore._(videoEffectStyleItem.name),
            });
            width && height && list.push({ title: 'resolution-desc', content: `${width} * ${height} px` });
        } else if (isVideoGeneration) {
            modelType &&
                list.push({
                    title: 'mode-desc',
                    content: FJLocalStore._(modelType === 'v1.5' ? 'professional' : modelType),
                });
        } else {
            if (appType === FJAppConstant.PHOTO_REMOVE_BG || appType === FJAppConstant.VIDEO_REMOVE_BG) {
                list.push({
                    title: 'selection-methods',
                    content: isCustomRemoveBg ? FJLocalStore._('customize-remover') : FJLocalStore._('auto-remover'),
                });
            }

            model && list.push({ title: 'model-desc', content: FJLocalStore._(model) });
            if (style && appType === FJAppConstant.IMAGE_TO_IMAGE) {
                const styleItem = this.getImgToImgDataStyleItem(style);
                const styleItemName = styleItem ? styleItem.name : style;
                list.push({ title: 'style-desc', content: FJLocalStore._(styleItemName) });
            } else {
                style && list.push({ title: 'style-desc', content: FJLocalStore._(style) });
            }
            if (appType === FJAppConstant.AI_HAIRSTYLE_CHANGER) {
                hairstyleInfo?.key &&
                    hairstyleInfo.key !== HAIR_STYLE_NO_CHANGE_KEY &&
                    list.push({ title: 'hairstyle-desc', content: FJLocalStore._(hairstyleInfo.key) });
                // 发色和发型仅显示一种信息：在选择发型发色之后只显示发型；在发色tab选择发色，有且仅有发色
                if (!hairstyleInfo?.key)
                    hairColorInfo?.key &&
                        hairColorInfo.key !== HAIR_COLOR_NO_CHANGE_KEY &&
                        list.push({ title: 'hair-color-desc', content: FJLocalStore._(hairColorInfo.key) });
            }

            if (appType === FJAppConstant.AI_VIDEO_GENERATOR) {
                aspectRatio && list.push({ title: 'ratio-desc', content: aspectRatio });
            } else {
                ratio && list.push({ title: 'ratio-desc', content: FJUtil.floor(ratio) });
            }

            if (appType === FJAppConstant.CLOTHES_CHANGER) {
                clothesModelType &&
                    list.push({
                        title: 'model-desc',
                        content: FJLocalStore._(clothesModelType === 'doubao' ? 'Max' : 'Pro'),
                    });
            }

            quality && list.push({ title: 'quality-desc', content: FJLocalStore._(quality) });
            color && list.push({ title: 'colorizer-color', content: FJLocalStore._(color) });
            upscaleSize && list.push({ title: 'upscale-size-desc', content: upscaleSize + 'X' });
            width && height && list.push({ title: 'resolution-desc', content: `${width} * ${height} px` });
        }
        createTime && list.push({ title: 'date-desc', content: FJUtil.convertToCurrentTimezone(createTime) });

        return list;
    },

    getSortHistoryList: function (historyList, sortType) {
        return historyList.filter(item => {
            switch (sortType) {
                case 'all-videos':
                    return true;
                case 'text-to-video':
                    return item.generationType === 'tv';
                case 'image-to-video':
                    return item.generationType === 'iv';
                case 'ai-video-effect':
                    return item.generationType === 'ev';
                default:
            }
        });
    },
    getPaymentLevel: function () {
        return window?.fj?.currentPlan?.package;
    },
    // 是否是免费用户
    isFreePayment: function () {
        if (FJUtil.isLocalhost()) {
            return true;
        }
        return FJUtil.getPaymentLevel() === 'free';
    },
    getToolName: function (appType = FJConfig.appType) {
        if (appType === FJAppConstant.TEXT_TO_SPEECH) {
            return FJTextToSpeechUtil.getToolName();
        }
        return appType.replaceAll('-', ' ');
    },

    getAudioHistoryList: function (list, index) {
        switch (index) {
            case 0:
                return list;
            case 1:
                return list.filter(item => item.audioTagType === FJConstant.AUDIO_TAG_TYPE_MUSIC);
            case 2:
                return list.filter(item => item.audioTagType === FJConstant.AUDIO_TAG_TYPE_INST);
            case 3:
                return list.filter(item => item.audioTagType === FJConstant.AUDIO_TAG_TYPE_SFX);
            default:
                return list;
        }
    },
    filterLanguageList: function (list, value, jsonValue) {
        const useValue = value.trim();
        if (useValue === '') {
            return list;
        }
        let firstArray = [];
        let array = [];
        list.forEach(item => {
            const label = FJLocalStore._(item[jsonValue || 'languageKey']);
            if (label.toLowerCase() === useValue.toLowerCase()) {
                firstArray.push(item);
            } else {
                const index = label.toLowerCase().indexOf(useValue.toLowerCase());
                if (index !== -1) {
                    if (!array[index]) {
                        array[index] = [];
                    }
                    array[index].push(item);
                }
            }
        });
        array.unshift(firstArray);
        return array.flat();
    },
    /**
     *
     * @param {*} taskIds
     * @param {*} pollingInterval
     * @returns {'event_id':out_put}
     */
    pollingTasks: function (taskIds, pollingInterval = TASK_POLLING_INTERVAL) {
        let timer = null;
        let errorTime = 0;
        let taskList = [...taskIds];
        const result = {};
        return new Promise(resolve => {
            const _error = () => {
                _complete();
                clearTimeout(timer);
                timer = null;
            };
            const _complete = () => {
                //任务结束
                resolve(result);
            };
            const _request = async () => {
                try {
                    if (taskList.length == 0) {
                        _complete();
                        return;
                    }
                    let data = await FJNetworkStore.getTaskState(taskList.join(','));
                    if (!data) {
                        errorTime++;
                        if (errorTime >= MAX_POLLING_ERROR_TIME) {
                            _error();
                        } else {
                            timer = setTimeout(_request.bind(null, taskList), pollingInterval);
                        }
                        return;
                    }
                    if (!Array.isArray(data)) {
                        // 处理数组类型的data
                        data = [data];
                    }
                    for (let i = 0; i < data.length; i++) {
                        const item = data[i];
                        const { event_id: eventId } = item;
                        switch (item.job_state) {
                            case 'succeeded':
                                if (item.out_put) {
                                    result[item.event_id] = { data: item, type: FJConstant.SUCCESS };
                                }
                                taskList = taskList.filter(i => i !== eventId);
                                break;
                            case 'waiting':
                                break;
                            case 'processing':
                                break;
                            case 'canceled':
                                result[item.event_id] = { data: item, type: FJConstant.CANCEL };
                                taskList = taskList.filter(i => i !== eventId);
                                break;
                            case 'timeout':
                            case 'failed':
                                result[item.event_id] = { data: item, type: FJConstant.ERROR };
                                taskList = taskList.filter(i => i !== eventId);
                                break;
                            default:
                                break;
                        }
                    }

                    timer = setTimeout(_request.bind(null), pollingInterval);
                } catch (error) {
                    _error();
                }
            };
            timer = setTimeout(_request.bind(null), pollingInterval);
        });
    },
    getTextBySlateNodes: value => {
        return value
            .map(item => {
                if (item.type === 'select') return item.value;
                else if (item.type === 'paragraph' || item.type === 'input' || item.type === 'preInput')
                    return item.children[0].text;
            })
            .join('');
    },
    /**
     * 将文本转换为slate节点 aaa = input xxx = select, bbb = input with preValue
     * @param {*} data
     * @returns
     */
    convertToSlateNodes: data => {
        const parts = data.text.split(/(aaa|xxx|bbb)/); // 分割文本，保留分隔符
        const nodes = [];
        let optionIdx = 0;
        let placeholderIdx = 0;
        let preValueIdx = 0;
        parts.forEach(part => {
            if (part === 'aaa') {
                nodes.push({
                    type: 'input',
                    placeholder: Array.isArray(data.placeholder) ? data.placeholder[placeholderIdx] : data.placeholder,
                    children: [{ text: '' }],
                });
                placeholderIdx++;
            } else if (part === 'bbb') {
                nodes.push({
                    type: 'preInput',
                    placeholder: Array.isArray(data.placeholder) ? data.placeholder[preValueIdx] : data.placeholder,
                    preValue: Array.isArray(data.preValue) ? data.preValue[preValueIdx] : data.preValue,
                    children: [
                        {
                            text: '',
                        },
                    ],
                });
                preValueIdx++;
            } else if (part === 'xxx') {
                nodes.push({
                    type: 'select',
                    value: data.options[optionIdx][0], // 默认选择第一个选项
                    options: data.options[optionIdx],
                    children: [{ text: '' }],
                });
                optionIdx++;
            } else if (part) {
                nodes.push({
                    type: 'paragraph',
                    children: [{ text: part }],
                });
            }
        });

        return nodes;
    },
    getRemoveLocalString: function (pathname = window.location.pathname, replaceString = '/') {
        const localString = LOCAL_STRING_LIST.find(item => pathname.includes(item));
        if (localString) {
            return pathname.replace(localString + replaceString, '');
        }
        return pathname;
    },
    getAIToolHref: function (currentMenuName) {
        const { pathname } = window.location;
        const { aiMenuList } = FJHeaderConfig;
        if (currentMenuName === FJAppConstant.AI_COMMUNITY) {
            return this.getRemoveLocalString();
        }
        // 处理文字转语音的特殊情况
        if (currentMenuName === 'ai-text-to-speech') {
            const title = pathname.includes('voice-cloning') ? 'ai-voice-cloning' : currentMenuName;
            return aiMenuList.find(item => item.title === title)?.href;
        }

        // 处理视频生成器的特殊情况
        if (currentMenuName === 'ai-video-generator') {
            // 路径和标题的映射关系
            const pathToTitle = {
                'image-to-video': AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO,
                'text-to-video': AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO,
                'video-effect': AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO,
            };

            // 查找匹配的路径并获取对应的标题
            const matchingPath = Object.keys(pathToTitle).find(path => pathname.includes(path));
            const title = matchingPath ? pathToTitle[matchingPath] : currentMenuName;

            return aiMenuList.find(item => item.title === title)?.href;
        }

        // 默认情况
        return aiMenuList.find(item => item.title === currentMenuName)?.href;
    },
    /**
     * @description 现在在进行预览时，当达到字符数限制，不会从预览句中截断，会找到最近的断句标点符号，空格作为预览结尾。（标点包括英文，中文标点 ,.，。；、……?!）
     * @param value
     * @returns {*}
     */
    getPreviewText(value) {
        const __isPunctuation = character => {
            return (
                /^[\u3000-\u303F\uFF01-\uFF20\uFF3B-\uFF40\uFFE0-\uFFE5]+$/.test(character) ||
                // eslint-disable-next-line no-useless-escape
                /^[!-\/:-@\[-`{-~]+$/.test(character)
            );
        };
        const sliceLength = 150;
        let preText = value.slice(0, sliceLength);
        if (__isPunctuation(preText.charAt(preText.length - 1))) {
            return preText;
        }

        let i = 1;
        let aCheckChar = value.slice(sliceLength, sliceLength + i);
        while (__isPunctuation(aCheckChar)) {
            i++;
            aCheckChar = value.slice(sliceLength + i - 1, sliceLength + i);
        }
        return preText;
    },

    /**
     * @description 通过图片链接获取图片的宽高和分辨率
     * @param {string} imageUrl - 图片链接
     * @returns {Promise<{width: number, height: number, resolution: number, aspectRatio: string}>}
     */
    getImageDimensionsFromUrl: function (imageUrl) {
        return new Promise((resolve, reject) => {
            if (!imageUrl) {
                reject(new Error('Image URL is required'));
                return;
            }

            const img = new Image();

            // 设置跨域属性（如果需要）
            img.crossOrigin = 'anonymous';

            img.onload = function () {
                const width = this.naturalWidth;
                const height = this.naturalHeight;
                const resolution = `${width} * ${height} px`;

                // 计算宽高比（简化为常见比例）
                const aspectRatio = FJRequirementsUtil.calculateAspectRatio(width, height);

                resolve({
                    width,
                    height,
                    resolution,
                    aspectRatio,
                    ratio: width / height,
                });
            };

            img.onerror = function () {
                reject(new Error(`Failed to load image: ${imageUrl}`));
            };

            // 添加时间戳避免缓存问题
            const separator = imageUrl.includes('?') ? '&' : '?';
            img.src = `${imageUrl}${separator}t=${Date.now()}`;
        });
    },

    /**
     * @description 计算图片的宽高比并返回标准比例字符串
     * @param {number} width - 图片宽度
     * @param {number} height - 图片高度
     * @returns {string} 标准比例字符串，如 "16:9", "4:3", "1:1" 等
     */
    calculateAspectRatio: function (width, height) {
        if (!width || !height) {
            return '1:1';
        }

        // 计算最大公约数
        const gcd = (a, b) => (b === 0 ? a : gcd(b, a % b));
        const divisor = gcd(width, height);

        const ratioWidth = width / divisor;
        const ratioHeight = height / divisor;

        // 标准比例映射
        const standardRatios = {
            '16:9': 16 / 9,
            '9:16': 9 / 16,
            '4:3': 4 / 3,
            '3:4': 3 / 4,
            '1:1': 1,
            '21:9': 21 / 9,
            '9:21': 9 / 21,
            '5:4': 5 / 4,
            '4:5': 4 / 5,
            '3:2': 3 / 2,
            '2:3': 2 / 3,
        };

        const currentRatio = width / height;
        let closestRatio = '1:1';
        let minDifference = Math.abs(currentRatio - 1);

        // 找到最接近的标准比例
        Object.entries(standardRatios).forEach(([ratio, value]) => {
            const difference = Math.abs(currentRatio - value);
            if (difference < minDifference) {
                minDifference = difference;
                closestRatio = ratio;
            }
        });

        // 如果差异太大，返回原始比例
        if (minDifference > 0.1) {
            return `${ratioWidth}:${ratioHeight}`;
        }

        return closestRatio;
    },

    /**
     * @description 批量获取多个图片的尺寸信息
     * @param {string[]} imageUrls - 图片链接数组
     * @returns {Promise<Array>} 包含每个图片尺寸信息的数组
     */
    getBatchImageDimensions: async function (imageUrls) {
        if (!Array.isArray(imageUrls) || imageUrls.length === 0) {
            return [];
        }

        const promises = imageUrls.map(async (url, index) => {
            try {
                const dimensions = await this.getImageDimensionsFromUrl(url);
                return {
                    index,
                    url,
                    success: true,
                    ...dimensions,
                };
            } catch (error) {
                return {
                    index,
                    url,
                    success: false,
                    error: error.message,
                    width: 0,
                    height: 0,
                    resolution: 0,
                    aspectRatio: '1:1',
                    ratio: 1,
                };
            }
        });

        return Promise.all(promises);
    },
    getABTest: function () {
        const uid = this.getUserId() || _abTestId;
        return Number(uid) % 2 === 0 ? true : false;
    },
    isEditPage: function () {
        return window.isEditPage;
    },
    isAiVideoGeneratorLandingPage: function () {
        return window.isAiVideoGeneratorLandingPage;
    },
    isLandingPage: function () {
        return this.isAiVideoGeneratorLandingPage();
    },
    isSpecialPage: function () {
        return this.isEditPage() || this.isAiVideoGeneratorLandingPage();
    },
    getRootId: function () {
        return this.isSpecialPage() ? 'ai-tool-root' : 'root';
    },
    getAbbrNumber: function (num, abbrSuffix = '') {
        if (num < 1000) {
            return num;
        } else if (num < 10000) {
            return (num / 1000).toFixed(1) + 'K' + abbrSuffix;
        } else if (num < 1000000) {
            return (num / 10000).toFixed(1) + 'M' + abbrSuffix;
        } else {
            return (num / 1000000).toFixed(1) + 'B';
        }
    },
    getShareLink: function (shareKey) {
        return FJConfig.serverPath + `ai-share/${shareKey}.html`;
    },
    shareToSociety: function (type, shareLink) {
        const __open = url => {
            let popWidth = 600;
            let popHeight = 480;
            let left = window.innerWidth / 2 - popWidth / 2 + window.screenX;
            let top = window.innerHeight / 2 - popHeight / 2 + window.screenY;
            let popParams =
                'scrollbars=no, width=' + popWidth + ', height=' + popHeight + ', top=' + top + ', left=' + left;
            let newWindow = window.open(url, '', popParams);

            if (window.focus) {
                newWindow.focus();
            }
        };

        switch (type) {
            case FJConstant.FACEBOOK:
                __open('https://www.facebook.com/sharer/sharer.php?u=' + shareLink);
                break;
            case FJConstant.TWITTER:
                __open('https://twitter.com/intent/tweet?url=' + shareLink);
                break;
            case FJConstant.TUMBLR:
                __open('https://www.tumblr.com/widgets/share/tool?posttype=link&canonicalUrl=' + shareLink);
                break;
            case FJConstant.COPY_LINK:
                FJUtil.copyText(shareLink);
                FJMessageStore.addMessage(FJLocalStore._('link-copied'));

                break;
            default:
                break;
        }
    },
};
export default FJRequirementsUtil;
